import { render, staticRenderFns } from "./EnergyLabel.vue?vue&type=template&id=79e4083a&scoped=true"
import script from "./EnergyLabel.vue?vue&type=script&lang=js"
export * from "./EnergyLabel.vue?vue&type=script&lang=js"
import style0 from "./EnergyLabel.vue?vue&type=style&index=0&id=79e4083a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4083a",
  null
  
)

export default component.exports